import React from 'react'

export default function MarginLeftRight({ color = '', style = {} }) {
    let fillColor = '#7246B1'
    if (color) fillColor = color
    let className = 'icons-icon'
    return (
        <svg
            className={className}
            style={style}
            xmlns='http://www.w3.org/2000/svg'
            width='20'
            height='20'
            viewBox='0 0 20 20'
            fill='none'
        >
            <path d='M3 5V15V5Z' fill={color} />
            <path d='M3 5V15' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <path d='M17 5V15' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
            <rect x='6' y='5' width='8' height='10' rx='2' stroke={color} strokeWidth='1.25' strokeLinecap='round' />
        </svg>
    )
}
